import { render, staticRenderFns } from "./InquiryFidaCode.vue?vue&type=template&id=a99f5a1a&"
import script from "./InquiryFidaCode.vue?vue&type=script&lang=js&"
export * from "./InquiryFidaCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports